// VideoContext.js
import { createContext, useState, useEffect } from 'react';

export const VideoContext = createContext();

export const VideoProvider = ({ children }) => {
  const [localStream, setLocalStream] = useState(null);
  const [remoteStream, setRemoteStream] = useState(null);
  const [callDuration, setCallDuration] = useState("00:00");
  const [display, setDisplay] = useState(false);
  const [callStatus, setCallStatus] = useState("idle");
  const [senderId, setSenderId] = useState("");
  const [receiverId, setReceiverId] = useState("");
  const [isScreenSharing, setIsScreenSharing] = useState(false);
  // Add other necessary states

  const startLocalStream = async () => {
    const stream = await navigator.mediaDevices.getUserMedia({ video: true, audio: true });
    setLocalStream(stream);
  };

  const startLocalAudioStream = async () => {
    const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
    setLocalStream(stream);
  };

//   const handleCallStart = () => {
//     // Implementation to start call
//   };

//   const endCall = () => {
//     // Implementation to end call
//   };

  return (
    <VideoContext.Provider value={{
      localStream,
      remoteStream,
      callDuration,
      display,
      callStatus,
      senderId,
      receiverId,
      isScreenSharing,
      startLocalStream,
      startLocalAudioStream,
    //   endCall,
      // Pass other functions and states
    }}>
      {children}
    </VideoContext.Provider>
  );
};